import { render, staticRenderFns } from "./HelpFirstPage.vue?vue&type=template&id=4a154c4b&"
import script from "./HelpFirstPage.vue?vue&type=script&lang=js&"
export * from "./HelpFirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports